var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 8,
    fill: "#E5734B",
    stroke: "#E5734B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.704 13.336C8.472 13.336 8.312 13.308 8.224 13.252C8.136 13.188 8.092 13.088 8.092 12.952V7.96C8.092 7.704 8.332 7.576 8.812 7.576H9.328C9.56 7.576 9.736 7.604 9.856 7.66C9.984 7.716 10.048 7.8 10.048 7.912L9.448 12.952C9.432 13.088 9.384 13.188 9.304 13.252C9.224 13.308 9.068 13.336 8.836 13.336H8.704ZM8.572 16.024C8.092 16.024 7.852 15.896 7.852 15.64V14.536C7.852 14.28 8.092 14.152 8.572 14.152H8.956C9.436 14.152 9.676 14.28 9.676 14.536V15.64C9.676 15.896 9.436 16.024 8.956 16.024H8.572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.781c53e5e04c70fb7c2f2c5a1c47e03f.svg";
export { ForwardRef as ReactComponent };